import {put,takeLatest,call} from 'redux-saga/effects';
import * as venueService from "../../../services/venueService";
import {
    GET_VENUE,
    GET_VENUE_SUCCESS,
    GET_VENUE_ERROR
}
    from "../../actions/venue";

function* getVenueSaga(action) {
    try {
        const data=yield call(venueService.GetVenue,action.payload)

        yield put({
            type: GET_VENUE_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_VENUE_ERROR,error: error.data
        });
    }
}


export function* getVenueSagaWatcher() {
    yield takeLatest(GET_VENUE,getVenueSaga);
}